package org.solyton.solawi.bid.module.bid.component.styles

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

val actionButtonColor: CSSColorValue = Color.darkgray
val actionButtonBgColor: CSSColorValue = Color.transparent
